/*eslint-disable*/
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';

import {
    Row,
    Col,
} from "reactstrap";
import './roadmapActivity.scss'

const RoadmapActivity = ({
    activities,
    comentsUpvote,
}) => {
    const getAvatar = (user) => {
        return (
            user[0].toUpperCase()
        )
    };

    const upvoteHandler = (activity) => {
        // write code to upvote activity
        //comentsUpvote(activity);
    }

    return (
        <div className="activity-main">
            <h3>Activity ({activities.length})</h3>
            <div className="_items">
                {
                    activities?.map((activity, index) => (
                        <div className="_item" key={index}>
                            {
                                activity.type === 'comment' && (
                                    <>
                                        <Row className="_item-title">
                                            <div className="avatar">
                                                {getAvatar(activity.createdBy.name)}
                                            </div>
                                            <Col className="_item-title-text">
                                                <span style={{ fontWeight: 'bold' }}>{activity.createdBy.name}</span>
                                                <span className="_item-title-text-date">
                                                    {/* hh:mm a */}
                                                    <Moment format="DD MMM YYYY">{activity.created_at['$date']}</Moment>
                                                </span>

                                                <div className="_comments">
                                                    <span>{activity.contents.text}</span>
                                                </div>

                                                {/* <div className="_reactions" onClick={() => upvoteHandler(activity)}>
                                                    <FontAwesomeIcon icon={faThumbsUp} />
                                                </div> */}
                                            </Col>
                                        </Row>

                                    </>

                                )
                            }

                        </div>
                    ))

                }
            </div>
        </div>
    );
};

export default RoadmapActivity;
